import {produce} from 'immer';

import {DataFrameColumns} from 'data-frames/DataFrameTypes';
import {ResultSchema} from 'results/assay-schemas/AssaySchemaConstants';

import {DataFrameColumnToFieldMapping, DataMappingState} from './DataMappingTypes';
import getDefaultColumnMapping from './getDefaultColumnMapping';

/**
 * Generate an updated DataMappingState with a new result schema.
 *
 * Clears any other state that depends on the previous result schema.
 */
export function updateResultSchema(
  state: DataMappingState,
  resultSchema: ResultSchema | null,
  columns: DataFrameColumns
): DataMappingState {
  return produce(state, (draftState) => {
    draftState.resultSchema = resultSchema;
    draftState.mappings = resultSchema == null ? [] : getDefaultColumnMapping(columns, resultSchema);
  });
}

/**
 * Generate an updated DataMappingState with new mappings.
 *
 * Clears any other state that depends on previous mappings.
 */
export function updateMappings(
  state: DataMappingState,
  mappings: Array<DataFrameColumnToFieldMapping>
): DataMappingState {
  return produce(state, (draftState) => {
    draftState.mappings = mappings;
  });
}
